import instance from '../helpers/interceptor';

export const refreshUserData = async () => {
  console.log('auth-service: refreshUserData called');
  try {
    const response = await instance.post('/login/sendUserData');

    if (response.statusCode === '0000') {
      console.log('auth-service: User data refreshed successfully');
      sessionStorage.setItem('userData', JSON.stringify(response.data));
      sessionStorage.setItem('AuthorizedSessions', JSON.stringify(response.data.authorizedSessions || {}));
      
      // Dispatch event to notify components about role/menu update
      window.dispatchEvent(new Event('roleUpdated'));
      
      return response.data;
    } else {
      throw new Error(response.statusMsg || 'Failed to refresh user data');
    }
  } catch (error) {
    console.error('Error refreshing user data:', error);
    throw error;
  }
};
